import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { TAM, MANAGED, InvoicingReportContext } from '../InvoicingReportContext'

import ReportContent from './ReportContent'

import TicketInvoiceReportCard from 'Components/Reports/Invoicing/ReportCard'
import { cloudhelpGet } from 'Utilities/CloudHelp'

class TicketsInvoicedReport extends React.Component {
  constructor (props) {
    super(props)
    const { activeFilters: { startTime, endTime, clientsList } } = props
    const [managedClients, timeAndMaterialsClients] = _.partition(clientsList, c => c.isManaged)

    this.state = {
      tickets: [],
      filters: {
        canShowReviewed: false,
        loading: false,
        startTime,
        endTime,
        clientType: MANAGED,
        clients: { [TAM]: timeAndMaterialsClients, [MANAGED]: managedClients },
        showReviewed: false,
        clientsSelected: [],
        allClients: false
      }
    }
  }

  gatherData = () => {
    const { paths: { apiTicketsInvoicedReportPath } } = this.props
    const {
      filters: {
        startTime: startTimeFilter,
        endTime: endTimeFilter,
        clientsSelected
      }
    } = this.state

    const selectedClientIds = _.map(clientsSelected, client => client.value)

    this.updateFilters({ loading: true })
    const params = {
      report: {
        start_time: startTimeFilter,
        end_time: endTimeFilter,
        client_ids: selectedClientIds
      }
    }

    cloudhelpGet(apiTicketsInvoicedReportPath, params)
      .then(({
        data: {
          tickets
        }
      }) => {
        this.setState({
          tickets
        })
        this.updateFilters({ loading: false })
      })
  }

  updateFilters = (newFilterState, stateCallback) => {
    this.setState(
      prevState => ({ filters: { ...prevState.filters, ...newFilterState } }),
      stateCallback
    )
  }

  updateFiltersClientType = (newFilterState, stateCallback) => {
    this.setState(
      prevState => ({ filters: {
        ...prevState.filters,
        ...newFilterState,
        clientsSelected: [],
        allClients: false
      } }),
      stateCallback
    )
  }

  updateSelectAllClients = (value) => {
    this.setState(
      prevState => ({
        filters: {
          ...prevState.filters,
          allClients: value,
          clientsSelected: value ? prevState.filters.clients[prevState.filters.clientType] : []
        } })
    )
  }

  render () {
    const { localStoragePrefix } = this.props
    const { tickets, filters } = this.state
    const { updateFilters, gatherData, updateSelectAllClients, updateFiltersClientType } = this
    const { showReviewed, loading, allClients } = filters

    const reportState = {
      filters,
      updateFilters,
      gatherData,
      updateSelectAllClients,
      updateFiltersClientType
    }

    return (
      <InvoicingReportContext.Provider value={reportState}>
        <TicketInvoiceReportCard>
          <ReportContent
            {...{
              updateFilters,
              showReviewed,
              loading,
              tickets,
              localStoragePrefix,
              gatherData,
              allClients,
              updateSelectAllClients
            }}
          />
        </TicketInvoiceReportCard>
      </InvoicingReportContext.Provider>
    )
  }
}

TicketsInvoicedReport.propTypes = {
  paths: PropTypes.shape({
    apiTicketsInvoicedReportPath: PropTypes.string.isRequired
  }).isRequired,
  activeFilters: PropTypes.shape({
    startTime: PropTypes.string,
    endTime: PropTypes.string
  }),
  localStoragePrefix: PropTypes.string
}

TicketsInvoicedReport.defaultProps = {
  activeFilters: {
    start_time: new Date(),
    end_time: new Date()
  },
  localStoragePrefix: 'ticketsInvoicedReport'
}

export default TicketsInvoicedReport
